import { render, staticRenderFns } from "./UCAppHeader.vue?vue&type=template&id=c524997e&"
import script from "./UCAppHeader.vue?vue&type=script&lang=ts&"
export * from "./UCAppHeader.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports